import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "randz_admin_token";

export const adminApi = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        const { data } = await axios.post(`${BACKEND}/api/auth/refresh`, {}, { withCredentials: true });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        orig.headers.Authorization = `Bearer ${data.access_token}`;
        return adminApi(orig);
      } catch {
        localStorage.removeItem(TOKEN_KEY);
        if (window.location.pathname.startsWith("/admin")) window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
